module.exports = __webpack_public_path__ + "static/img/22.0a674fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/loading/img/22.png
// module id = mAR6
// module chunks = 0